import script from "./EmployeePermissionMatrix.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeePermissionMatrix.vue?vue&type=script&setup=true&lang=js"

import "./EmployeePermissionMatrix.vue?vue&type=style&index=0&id=20dcb39a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20dcb39a"]])

export default __exports__